import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Done from '@material-ui/icons/Done';

import roleDisabled from 'services/roleDisabled/index';
import BusyButton from 'components/BusyButton/BusyButton';

const propTypes = {
  userAccess: PropTypes.arrayOf(PropTypes.string).isRequired,
  allowedAccess: PropTypes.arrayOf(PropTypes.string).isRequired,
  submitting: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  classes: PropTypes.shape({}).isRequired,
};

export function UnstyledRBACSubmitButton({
  userAccess,
  allowedAccess,
  submitting,
  disabled,
  classes,
}) {
  const theButton = (buttonDisabled) => (
    <BusyButton
      loading={submitting}
      disabled={buttonDisabled}
      name="submit"
      type="submit"
      variant="fab"
      color="primary"
      size="small"
      className={classes.addButton}
      mini
    >
      <Done fontSize="large" />
    </BusyButton>
  );
  return roleDisabled(userAccess, allowedAccess) ? (
    <Tooltip title="You do not have the required access for this resource. Contact your organization owner.">
      <span>{theButton(true)}</span>
    </Tooltip>
  ) : (
    theButton(disabled)
  );
}

const styles = (theme) => ({
  addButton: {
    margin: theme.spacing(2),
  },
});

UnstyledRBACSubmitButton.propTypes = propTypes;

export default withStyles(styles)(UnstyledRBACSubmitButton);
